import { ChatAppResponse } from "../../api";

export function getEvidenceGraphAssessmentIds(answer: ChatAppResponse): string[] {
    const ids = new Set<string>();
    const citationIds = answer.context?.data_points?.citation_ids ?? {};
    Object.values(citationIds).forEach(id => addClinicalCitationId(ids, id));
    (answer.context?.data_points?.citations ?? []).forEach(citation => addClinicalCitationId(ids, citation));
    return Array.from(ids);
}

function addClinicalCitationId(ids: Set<string>, value: string | undefined) {
    if (!value) {
        return;
    }
    const trimmed = value.trim();
    if (!trimmed || trimmed.startsWith("http://") || trimmed.startsWith("https://")) {
        return;
    }
    const lastPathPart = trimmed.split("/").pop() ?? trimmed;
    if (lastPathPart.startsWith("SYN-NOTE-") || /^\d+$/.test(lastPathPart)) {
        ids.add(lastPathPart);
    }
}
